export const  store_links={
    customerPlaystore: 'https://play.google.com/store/apps/details?id=com.timezzicustomer',
    customerAppStore: 'https://apps.apple.com/us/app/timezzi/id6615079025',
    businessPlayStore: 'https://play.google.com/store/apps/details?id=com.timezzibusiness',
    businessAppStore: 'https://apps.apple.com/us/app/timezzi-partner/id6615079411',    
}